import { ComboBox, DefaultButton, PrimaryButton,Label, Icon, IComboBoxOption, IIconProps, TooltipHost } from "@fluentui/react";
import { getLocalizedStrings } from "../../lib/LocalizedStringsForDatePicker";
import { CustomDatePicker } from "./ImportAct";
import { User } from "../../system/User";
import { IactError } from "./InterfaceFormulario";
import { ItipoConcepto } from "../../system/projects/ProjectsSystem";
import useClipboardExcel from "../../common/custom-hooks/useClipboardExcel";
import { t } from "i18next";
import useIsMobile from "../../common/custom-hooks/useIsMobile";
import MessageCourier from "../../lib/MessageCourier";

interface ICustonearder{
  filteredCollaborators: IComboBoxOption[];
  collaboratorValue:string;
  handleSelectCollaborator:(option: IComboBoxOption | undefined) => Promise<void>;
  handleFilterCollaborator:(text: string) => void;
  periodo:Date;
  HandlerPeriodo:(date: Date) => void;
  horasTotal:number;
  convertMinToHour:(minutes: number) => string;
  desabled:boolean;
  UploadIcon:IIconProps;
  actError:IactError;
  tipoConcept:ItipoConcepto[];
  desableAddRow:boolean;
  HandlerAddRows:() => void;
  AddIcon:IIconProps;
  dataUser:User;
  mountBlock: {[key: number]: number[]};
  HandlercleanEverything:() => void;
  addrowlength:number;
  HandlerCopyToClipboard:() => void;
  HandlerDataFromExcel:(data:any) => void;
  courier: MessageCourier
}

const Custoneader = ({
    filteredCollaborators,
    collaboratorValue,
    handleSelectCollaborator,
    handleFilterCollaborator,
    periodo,
    HandlerPeriodo,
    horasTotal,
    convertMinToHour,
    desabled,
    UploadIcon,
    actError,
    tipoConcept,
    desableAddRow,
    HandlerAddRows,
    AddIcon,
    dataUser,
    mountBlock,
    HandlercleanEverything,
    addrowlength,
    HandlerCopyToClipboard,
    HandlerDataFromExcel,
    courier
  }:ICustonearder) =>{

    const { copyToClipboard, pasteFromClipboard } = useClipboardExcel();
    const { isMobile } = useIsMobile(768);
    const dataFromExcel = async () => {
      await pasteFromClipboard((processedData) => {
        HandlerDataFromExcel(processedData);
        courier.messageSuccess(t("Datos pegados desde el portapapeles. Verifica que los datos sean correctos antes de cargar."));
      });
    };

    return (
      <div className="ms-Grid-row">
{/*         {isActive && (
          <div>
            <ToastErrorAndExit
              message={t("Datos copiados al portapapeles. Pegalo en un Excel.")}
              tipe="exit"
              closeToast={handleCloseActive}
            />
          </div>
        )} */}
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg7">
            <ComboBox
              label={t("Colaborador")}
              className="ms-Grid-col ms-sm4 ms-md6 ms-lg4"
              options={filteredCollaborators}
              allowFreeform
              text={collaboratorValue}
              onChange={(_, option) => handleSelectCollaborator(option)}
              onInputValueChange={(text) =>
                handleFilterCollaborator(text || "")
              }
              selectedKey={"00000006454"}
              disabled={dataUser.isDirectiveUser() || dataUser.isStandardUser()}
            />
            {/*         <DatePicker
            label="Periodo"
            className="ms-Grid-col ms-sm6 ms-md4 ms-lg4"
            strings={getLocalizedStrings()}
            formatDate={DateCustom.formatDateForDatePicker_MMYYYY}
            calendarProps={{ isDayPickerVisible: false }}
            value={periodo}
            onSelectDate={(e) => {
              if (e) {
                let _date = new Date(e.getFullYear(), e.getMonth(), 1);
                HandlerPeriodo(_date);
              }
            }}
          /> 
          */}
            <CustomDatePicker
              strings={getLocalizedStrings()}
              label={t("Periodo")}
              value={periodo}
              blockedMonths={mountBlock}
              onSelectDate={(date) => HandlerPeriodo(date as Date)}
            />
            <div className="ms-Grid-col ms-sm4">
              <Label>{t('Horas pendientes')}</Label>
              <DefaultButton
                style={{
                  color: horasTotal > -1 ? "black" : "red",
                  border: "none",
                }}
              >
                {convertMinToHour(horasTotal)}
              </DefaultButton>
            </div>
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md6 ms-lg4"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            <PrimaryButton
              className="ms-Grid-col ms-sm12 ms-md6 ms-lg3"
              text={t("Cargar")}
              iconProps={UploadIcon}
              type="submit"
              disabled={desabled}
            />
          </div>
        </div>
        <div style={{ margin: "70px " }}></div>
        <div className="ms-Grid-col ms-sm12">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              padding: "20px 20px",
              marginBottom: "20px"
            }}
          >
            <Icon iconName="Info" style={{ marginRight: "5px" }} />
            <div className="ml-2">
              <li className="mb-1">
                {t('Los documentos serán cargados al proyecto/servicio')}
              </li>
              <li>
                {t('El 100% de la carga de la actividad irá a la empresa seleccionada')}
              </li>
            </div>
          </div>
        </div>
        {/* <div className="ms-Grid-row" style={{ padding: "30px 0px 10px 40px" }}>
          <h4 className="ms-Grid-col ms-sm11">
            Tienes {actError.actVali} filas válidas y {actError.actvErro} filas
            con errores
          </h4>
        </div> */}
        <div className="ms-Grid-row" style={{ padding: "0px 30px" }}>
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="ms-Grid-col ms-sm12 ms-md9"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px"
              }}
            >
              <PrimaryButton
                disabled={
                  tipoConcept.length === 0 ? true : desableAddRow ? true : false
                }
                text={t("Agregar fila")}
                iconProps={AddIcon}
                onClick={() => HandlerAddRows()}
              />
              <PrimaryButton
                disabled={addrowlength === 0 ? true : false}
                text={t("Eliminar todo")}
                onClick={() => HandlercleanEverything()}
              />
            </div>
            <div style={{ paddingTop: isMobile ? "24px" : "0px", marginLeft: isMobile ? "18px" : "0px" }}>
              <div
                className="ms-Grid-row"
                style={{
                  justifyContent: "flex-end",
                  display: "flex",
                  marginRight: 45,
                }}
              >
                <span style={{ marginTop:"5px", fontSize:"14px", marginRight:"10px"}}>{t("Copiar/Pegar desde Excel")}</span>
                <TooltipHost content={t("Copiar como Excel")}>
                  <DefaultButton
                    iconProps={{
                      iconName: "Copy",
                      styles: {
                        root: {
                          fontSize: "25px",
                        },
                      },
                    }}
                    ariaLabel={t("Copiar")}
                    styles={{
                      root: {
                        minWidth: "32px",
                        padding: 0,
                        border: "none",
                      },
                    }}
                    onClick={() => {
                      copyToClipboard(HandlerCopyToClipboard())
                      courier.messageSuccess(t("Datos copiados al portapapeles. Pegalo en un Excel."))
                    }}
                  />
                </TooltipHost>
                <TooltipHost content={t("Pegar desde Excel")}>
                  <DefaultButton
                    iconProps={{
                      iconName: "Paste",
                      styles: {
                        root: {
                          fontSize: "25px",
                        },
                      },
                    }}
                    ariaLabel={t("Pegar")}
                    styles={{
                      root: {
                        minWidth: "32px",
                        padding: 0,
                        border: "none",
                      },
                    }}
                    onClick={() => dataFromExcel()}
                  />
                </TooltipHost>
              </div>
            </div>
          </div>
        </div>
      </div>
    );};
  export default Custoneader;